import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'
import VueMeta from 'vue-meta'
import Main from './components/Main.vue'
import Posts from './components/Posts.vue'
import Post from './components/Post.vue'
import Page from './components/Page.vue'
import Landing from './components/Landing.vue'
import Parutions from './components/Parutions.vue'
import NotFound from './components/NotFound.vue'
import './../node_modules/bulma/css/bulma.css'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)


import VueSilentbox from 'vue-silentbox'
Vue.use(VueSilentbox)


Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueMeta)

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: function(to) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [{
        path: '/',
        component: Main,
        children: [
            // Main will be rendered inside Page's <router-view>
            { path: '', component: Landing, name: 'accueil' },
            { path: 'page/:id', component: Page, name: 'page' },
            { path: 'post/:id', component: Post, name: 'actualité' },
            { path: 'parutions', component: Parutions, name: 'parutions' },
            { path: 'posts', component: Posts, name: 'actualités' },
            { path: '*', component: NotFound, name: '404'},
        ]
    }]
})


var moment = require('moment')
moment.locale('fr')
// filters
Vue.filter('formatTimestamp', function(value) {
    if (value) {
        return moment.unix(value).format("DD/MM/YYYY")
    }
})
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value, 'YYYY-MM-DD').format("DD/MM/YYYY")
    }
})
Vue.filter('formatDate2', function(value) {
    if (value) {
        return moment(value, 'YYYY-MM-DD').format("MMMM YYYY")
    }
})
Vue.filter('capitalize', function(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('truncate', function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
})


Vue.prototype.$api_url_base = process.env.VUE_APP_APIPURI
Vue.prototype.$api_key = process.env.VUE_APP_APIKEY
Vue.prototype.$api_url_posts = Vue.prototype.$api_url_base + '/api/collections/get/post?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_pages = Vue.prototype.$api_url_base + '/api/collections/get/page?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_contact = Vue.prototype.$api_url_base + '/api/forms/submit/contact?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_carousels = Vue.prototype.$api_url_base + '/api/collections/get/carousel?token=' + Vue.prototype.$api_key
Vue.prototype.$api_url_infoscontact = Vue.prototype.$api_url_base + '/api/singletons/get/InfosContact?token=' + Vue.prototype.$api_key

// si code google analytics renseigner env var "VUE_APP_GTAG"
import VueGtag from "vue-gtag";
if(process.env.VUE_APP_GTAG && process.env.VUE_APP_GTAG.length > 10) {
    Vue.use(VueGtag, {
      config: { id: process.env.VUE_APP_GTAG }
    });
}

// global mixin
Vue.mixin({
    // update paths from API
    updated: function() {
        var curloc = window.location.origin
        // liens vers pages
        //const links = this.$el.querySelectorAll("a[href^='collection://']");
        const links = document.querySelectorAll("a[href^='collection://']");
        links.forEach((link) => {
            link.href = link.href.replace('collection://', "#/");
        });
        // liens fichiers
        const links2 = document.querySelectorAll("a[href^='/storage']")
        links2.forEach((link) => {
            var newhref = link.href.replace(curloc, '')
            newhref = this.$api_url_base + newhref
            link.href = newhref
            link.target = '_blank'
        });
        // liens images
        const imgs = document.querySelectorAll("img[src^='/storage']")
        imgs.forEach((img) => {
            var newsrc = img.src.replace(curloc, '')
            newsrc = this.$api_url_base + newsrc
            img.src = newsrc
        });
    },
    metaInfo () {
      return {
        title: this.maintitle,
        meta: [
          { vmid: 'title', name: 'title', content: this.title }
        ]
      }
    },
})

new Vue({
    render: h => h(App),
    router: router,
    data: function() {
        return {}
    },
}).$mount('#app')

//listeners
document.addEventListener('DOMContentLoaded', () => {

    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

            });
        });
    }

    let dropdown = document.querySelector('.dropdown');
    dropdown.addEventListener('click', function(event) {
        event.stopPropagation();
        dropdown.classList.toggle('is-active');
    });

    // close notifications
    (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
        var $notification = $delete.parentNode;
        $delete.addEventListener('click', () => {
            $notification.parentNode.removeChild($notification);
        });
    });

});